/**
 * Request header that opts ONE request out of the 90 second timeout in MainInterceptor.
 * The interceptor removes it before the request is sent, so the API never sees it.
 * Every other request keeps the site-wide timeout. Used by Dev Tools > EOM Processing, which has long running work.
 */
export const NO_TIMEOUT_HEADER = 'X-No-Timeout';



// WEBPACK FOOTER //
// ./src/app/core/constants/no-timeout-header.ts